<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'NewPayroll' })"
  >
    <form
      class="modal-card"
      style="width: auto"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Crear nuevo empleado
        </p>
        <button
          type="button"
          class="delete"
          @click="$router.push({ name: 'NewPayroll' })"
        />
      </header>
      <section class="modal-card-body">
        <NewEmployee :loading="loading" />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'NewPayroll' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Crear empleado
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'PushEmployee',
  components: {
    NewEmployee: () => import(/* webpackChunkName: "new-employee" */ '@/components/Admin/Payroll/NewEmployee.vue'),
  },
  data() {
    return { loading: false };
  },
  methods: {
    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('employee/create');
        this.$success({ message: 'Empleado creado exitosamente' });
        this.$router.push({ name: 'NewPayroll' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
</style>
